import React from 'react';
import { createComponent } from '@lit/react';
import { IxTabs as LitComp } from '../IxTabs.js';

customElements.define('ix-tabs', LitComp);

export const IxTabs = createComponent({
  tagName: 'ix-tabs-react',
  elementClass: LitComp,
  react: React,
});
